import BaseApiClient from '../BaseApiClient';
import { JobTitleInterface } from '@interfaces/JobTitle.interface';

export class ApiJobTitle extends BaseApiClient {
  /**
   * Get all items
   */
  async all(): Promise<Array<JobTitleInterface>> {
    return new Promise((resolve, reject) => {
      this.client
        .get('/job-title?page[size]=999')
        .then((res) => {
          if (res.data) {
            resolve(res.data.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }
}

export { jobTitleQueryKeys } from './query-keys';
export { useJobTitleAllQuery } from './use-job-title-queries';
